import React, { useContext, useEffect } from "react";

import {
  CardHeader,
  Paper,
  Box
} from "@material-ui/core";

import { Card, Centered } from "../../../../../common/components/libs";
import PageStoreContext from "../context";
import useTopItemsStatsFetcher from "../hooks/useTopItemsStatsFetcher";
import NoTopItemsReport from "./NoTopItemsReport";
import {useTranslation} from "react-i18next";
import TopItemsTable from "./tables/TopItemsTable";
import { observer } from "mobx-react";
import TopItemsCards from "./cards/TopItemsCards";


const TopCategories = () => {
  const {i18n, t} = useTranslation(["general", "stats"]);

  const pageStore = useContext(PageStoreContext);
  const [isLoading, result, filter, setFilter] = useTopItemsStatsFetcher();


  useEffect(() => {
    if(!pageStore.currentMenu){
      return;
    }

    setFilter({
      fromDate: pageStore.from.toDate(),
      toDate: pageStore.to.toDate(),
      limit: 10,
      menuId: pageStore.currentMenu.id,
    })
  }, [pageStore.currentMenu, pageStore.from, pageStore.to]);


  return (
    <Card mb={3}>
      <CardHeader
        title={t("stats:topPositions")}
      />
      {
        result.length > 0 && pageStore.generalStats ?  <Paper>
              <Box display={{ xs: "none", sm: "block", md: "block", lg: "block", xl: "block" }}>
                <TopItemsTable result={result}/>
              </Box>
              <Box display={{ xs: "block", sm: "none", md: "none", lg: "none", xl: "none" }}>
                <TopItemsCards result={result}/>
              </Box>
        </Paper>
            :
            <Centered>
              <NoTopItemsReport/>
            </Centered>
      }
    </Card>
  );
}

export default observer(TopCategories)
